import styled from "styled-components";

const Title = styled.h1`
  text-align: center;
  color: rgba(0, 185, 205, 1);
`;
export default Title;
